import pageUtils from '../modules/pageutils';
import header from '../modules/header';
import hamburger from '../modules/hamburger'; 
import sliders from '../modules/sliders'; 
import welcome from '../modules/welcome';
import enlargeButtons from '../modules/enlarge-buttons';
import archiveSliders from '../modules/archive-sliders';
import singleProduct from '../modules/single-product';
import timeline from '../modules/timeline';
import popupNewsletter from '../modules/popup-newsletter';
import comeTiSenti from '../modules/come-ti-senti';
import filters from '../modules/filters';
import videoPlayer from '../modules/video-player';
import latestPosts from '../modules/latest-posts';
import productsCarouselBlock from '../modules/products-carousel-block';
import productVideo from '../modules/product-video';

export default {
  init() {
    // JavaScript to be fired on all pages

  },
  finalize() {
    // Set Utilities
    pageUtils();
    header();
    sliders();
    welcome();
    enlargeButtons();
    archiveSliders();
    singleProduct();
    timeline();
    popupNewsletter();
    comeTiSenti();
    filters();
    videoPlayer();
    latestPosts();
    productsCarouselBlock();
    productVideo();

    // Hamburger
    let allHtml = document.querySelector('html'); 
    hamburger.register('body',{
        onOpen: () => {
          allHtml.style.overflow = 'hidden';
        },
        onClose: () => {
          allHtml.style.overflow = 'auto';
          document.body.classList.remove('is-mobile-panel-open'); 
          document.body.classList.remove('is-mobile-product-category-open');
          const mobile_items_panel_second = document.querySelectorAll('.js-mobile-panel-second');
          if (mobile_items_panel_second) {            
            mobile_items_panel_second.forEach(element => {
              element.classList.remove('is-active');
            });
          }
        },
    });
  }, //fine finalized
};